// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import {
  ToggleButtonGroup,
  styled,
  toggleButtonClasses,
  toggleButtonGroupClasses,
} from '@mui/material';
import { z } from 'zod';

export const zoneCompanySchema = z
  .object({
    id: z.string(),
    key: z.string(),
    name: z.string(),
    isCustomer: z.boolean(),
    isSupplier: z.boolean(),
    isArchived: z.boolean(),
    isManufacturer: z.boolean().default(false),
  })
  .nullable();

const zoneNameSchema = z
  .string({ required_error: 'Name is required' })
  .min(1, 'Name is required');

const inventoryModeSchema = z.enum(['inherit', 'yes', 'no']);

export type InventoryMode = z.infer<typeof inventoryModeSchema>;

export interface ZoneFormData {
  name: string;
  description: string;
  consignee: z.infer<typeof zoneCompanySchema>;
  inventoryMode: InventoryMode;
}

export const zoneFormOutputSchema = z.object({
  name: zoneNameSchema,
  description: z.string(),
  consignee: zoneCompanySchema,
  inventoryMode: inventoryModeSchema,
});

export type ZoneFormOutputData = z.infer<typeof zoneFormOutputSchema>;

export const InventoryButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonClasses.root}.${toggleButtonGroupClasses.grouped}`]: {
    border: 0,
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.shape.borderRadius,
    textTransform: 'none',
  },
}));
